export default defineNuxtPlugin(() => {
	if (import.meta.client) {
		let booted = false
		const bootstrapMetrika = () => {
			if (booted) return
			booted = true

			;(function (m, e, t, r, i, k, a) {
				m[i] =
					m[i] ||
					function () {
						;(m[i].a = m[i].a || []).push(arguments)
					}
				m[i].l = 1 * new Date()
				for (let j = 0; j < document.scripts.length; j++) {
					if (document.scripts[j].src === r) {
						return
					}
				}
				;(k = e.createElement(t)),
					(a = e.getElementsByTagName(t)[0]),
					(k.async = 1),
					(k.src = r),
					a.parentNode.insertBefore(k, a)
			})(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym')

			window.ym(103410368, 'init', {
				clickmap: true,
				trackLinks: true,
				accurateTrackBounce: true,
				webvisor: true,
			})
		}

		const bootFromUserIntent = () => {
			bootstrapMetrika()
			window.removeEventListener('pointerdown', bootFromUserIntent)
			window.removeEventListener('keydown', bootFromUserIntent)
			window.removeEventListener('scroll', bootFromUserIntent)
		}

		window.addEventListener('pointerdown', bootFromUserIntent, { once: true, passive: true })
		window.addEventListener('keydown', bootFromUserIntent, { once: true, passive: true })
		window.addEventListener('scroll', bootFromUserIntent, { once: true, passive: true })

		if ('requestIdleCallback' in window) {
			window.requestIdleCallback(() => bootstrapMetrika(), { timeout: 5000 })
		} else {
			window.setTimeout(() => bootstrapMetrika(), 3000)
		}
	}
})
